module.exports = __webpack_public_path__ + "img/first_two.80ade0be.png";